import type { AdjustmentType } from '../enums/AdjustmentType'

export class AdjustmentMiniEntity {
  id?: number
  amount?: number
  type?: AdjustmentType
  adjustmentReasonId?: number | null
  adjustmentReasonName?: string | null
  note?: string | null
  effectiveDate?: string
  driverFullName?: string | null
  driverWorkingPhoneNumber?: string | null
}
